import { FormLabel, FormControlLabel, FormControl, FormHelperText, RadioGroup, Radio } from "@mui/material";
import styles from "./styles";
import Commons from "@utils/utility";
import getUseStyles from "@styles/getUseStyles";
import { MvRadioPropsInterface } from "@mv-components/types";

const useStyles = getUseStyles(styles);

const RadioIcon = (props: MvRadioPropsInterface) => {
	const {
		value,
		onChange,
		extraClass,
		itemKey,
		label,
		options,
		helperLabel,
		variant,
		fromLabelClassName,
		disabled,
		minWidthClassName,
		labelPlacement,
	} = props;
	const { classes, cx } = useStyles() as any;
	return (
		<div className={cx(classes.root, extraClass)}>
			<FormControl
				component="fieldset"
				className={labelPlacement === "top" ? classes.formControlAlt : classes.formControl}
			>
				{label && (
					<div className={cx(minWidthClassName ? classes[minWidthClassName] : "")}>
						<FormLabel
							className={cx(
								fromLabelClassName ? classes[fromLabelClassName] : "",
								classes.formLabel,
								classes.formLabelCustomMargin
							)}
							classes={{
								focused: classes.formLabelFocused,
							}}
						>
							{label}
						</FormLabel>
						{Commons.getHelperTxt(props) && <div style={{ height: "22px" }}></div>}
					</div>
				)}

				<div>
					<RadioGroup
						name={itemKey}
						className={variant === "vertical" ? classes.groupColumn : classes.group}
						value={String(value)}
					>
						{options?.map((n: any) => {
							return (
								<FormControlLabel
									key={n.value}
									value={String(n.value)}
									label={n.name || n.label}
									onChange={(e) => {
										onChange({
											event: {
												...e,
												target: { ...e.target, value: n.value },
											},
											itemKey,
										});
									}}
									control={
										<Radio
											disabled={disabled}
											size="small"
											color="primary"
											disableRipple={true}
											classes={{
												disabled: classes.radioLabelDisabled,
												root: classes.radioControlRoot,
												colorPrimary: classes.radioHover,
											}}
										/>
									}
									className={cx(
										classes.radioLabelOptions,
										minWidthClassName ? classes[minWidthClassName] : ""
									)}
								/>
							);
						})}
					</RadioGroup>
					{helperLabel && (
						<FormLabel
							component="legend"
							className={classes.helperLabel}
							classes={{
								focused: classes.helperLabelFocused,
							}}
						>
							{helperLabel}
						</FormLabel>
					)}
					{Commons.getHelperTxt(props) ? (
						<FormHelperText className={classes.radioErrLabel} error={Commons.isError(props)}>
							{Commons.getHelperTxt(props)}
						</FormHelperText>
					) : null}
				</div>
			</FormControl>
		</div>
	);
};

export default RadioIcon;
